var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "component-container" },
    [
      _vm.isLoadingKanban
        ? _c("SpinnerLayerComponent", { staticClass: "spinner-layer" })
        : _vm._e(),
      _c(
        "section",
        { staticClass: "lexon-kanban-container" },
        [
          _c(
            "ejs-kanban",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.renderEmptyKanbanDiv && !_vm.isLoadingKanban,
                  expression: "!renderEmptyKanbanDiv && !isLoadingKanban",
                },
              ],
              ref: "kanban",
              staticClass: "lexon-kanban",
              attrs: {
                keyField: "state",
                dataSource: _vm.kanbanData,
                cardSettings: _vm.cardSettings,
                swimlaneSettings: _vm.swimlaneSettings,
                enableTooltip: true,
                tooltipTemplate: _vm.tooltipTemplate,
                cssClass: _vm.swimlaneSettings.keyField,
                dialogSettings: _vm.dialogSettings,
                dragStop: _vm.saveAction,
                dragStart: _vm.checkIfDisableDragAndDrop,
                queryCellInfo: _vm.checkIfRenderEmptyKanbanDivFiltersBehaviour,
              },
            },
            [
              _c(
                "e-columns",
                _vm._l(_vm.kanbanColumns, function (column, columnIndex) {
                  return _c("e-column", {
                    key: columnIndex,
                    attrs: {
                      headerText: column.headerText,
                      keyField: column.keyField,
                      template: _vm.columnsTemplate,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.renderEmptyKanbanDiv,
                  expression: "renderEmptyKanbanDiv",
                },
              ],
              staticClass: "empty-kanban",
            },
            [
              _c("span", { class: [_vm.noResultsIcon, "no-registers-icon"] }),
              _c("span", { staticClass: "text" }, [
                _vm._v(
                  _vm._s(_vm.$t("components.no_results.no_search_results_text"))
                ),
              ]),
              _c("span", { staticClass: "text try-again" }, [
                _vm._v(_vm._s(_vm.$t("components.no_results.try_again"))),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }